<template>
  <div class="container pdf-print-customer">
    <b-overlay :show="loading" opacity="0.99">
      <ErrorsMessages :errors="errors" />
      <div v-show="errors.length == 0">
        <v-btn class="v-warning float-right mt-2" v-on:click="printOut"
          >IMPRIMIR</v-btn
        >
        <table>
          <tbody>
            <tr>
              <td>
                <div>
                  <table class="table">
                    <tr>
                      <td>
                        <div class="d-flex align-items-center">
                          <img
                            v-if="rest_home_logo_url"
                            class="rest_home_logo_url"
                            :src="rest_home_logo_url"
                          />
                          <div v-if="!rest_home_logo_url" class="ml-1">
                            <strong class="text-uppercase">{{
                              rest_home_name
                            }}</strong>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <img
                            v-if="customer.photo_url"
                            :src="customer.photo_url"
                          />
                          <img
                            v-if="!customer.photo_url"
                            :src="require('../../assets/user.png')"
                            width="70"
                          />
                          <div class="ml-1">
                            <p class="m-0">
                              <strong>
                                {{ customer.name }}
                              </strong>
                            </p>
                            <p class="m-0" v-if="customer.date_of_birth">
                              <span class="text-muted"
                                >Data de nascimento:
                              </span>
                              {{ formatDate(customer.date_of_birth, false) }}
                              -
                              {{ getAge(customer.date_of_birth) }}
                              anos
                            </p>
                            <p class="m-0" v-if="customer.date_of_birth">
                              {{ getAge(customer.date_of_reception) }}
                              ano(s)
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <img class="logo" :src="logo" />
                          <br />
                          <span>
                            Cadastrado:
                            {{ formatDate(customer.created_at, false) }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <tbody>
            <tr>
              <th colspan="2">INFORMAÇÕES</th>
            </tr>
            <tr>
              <td>GRAU DE PARENTESCO</td>
              <td>{{ customer.type_of_customer_name }}</td>
            </tr>
            <tr>
              <td>1º TELEFONE</td>
              <td>{{ customer.first_phone }}</td>
            </tr>
            <tr>
              <td>2º TELEFONE</td>
              <td>{{ customer.second_phone }}</td>
            </tr>
            <tr>
              <td>E-MAIL</td>
              <td>{{ customer.email }}</td>
            </tr>
            <tr>
              <td>DATA DE NASCIMENTO</td>
              <td>{{ formatDate(customer.date_of_birth, false) }}</td>
            </tr>
            <tr>
              <td>GÊNERO</td>
              <td>{{ customer.gender && customer.gender.name }}</td>
            </tr>
            <tr>
              <td>ESTADO CIVIL</td>
              <td>
                {{ customer.marital_status && customer.marital_status.name }}
              </td>
            </tr>
            <tr>
              <td>CPF</td>
              <td>{{ customer.cpf }}</td>
            </tr>
            <tr>
              <td>RG</td>
              <td>{{ customer.rg }}</td>
            </tr>
            <tr>
              <td>ORGÃO EXPEDIDOR</td>
              <td>{{ customer.issuing_body }}</td>
            </tr>
            <tr>
              <td>DATA DE EMISSÃO</td>
              <td>{{ formatDate(customer.date_of_issue, false) }}</td>
            </tr>
            <tr>
              <th class="2">ENDEREÇO</th>
            </tr>
            <tr>
              <td>CEP</td>
              <td>{{ customer.cep }}</td>
            </tr>
            <tr>
              <td>ENDEREÇO</td>
              <td>{{ customer.address }}</td>
            </tr>
            <tr>
              <td>Nº</td>
              <td>{{ customer.number_address }}</td>
            </tr>
            <tr>
              <td>BAIRRO</td>
              <td>{{ customer.neighborhood }}</td>
            </tr>
            <tr>
              <td>CIDADE</td>
              <td>{{ customer.city }}</td>
            </tr>
            <tr>
              <td>ESTADO</td>
              <td>{{ customer.uf && customer.uf.name }}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th>RESIDENTES VINCULADOS</th>
              <th class="text-center">RESPONSÁVEL PELO PAGAMENTO?</th>
              <th class="text-center">SACADOR AVALISTA?</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, key) in customer.customer_has_resident"
              :key="key"
            >
              <td>
                <div class="d-flex align-items-start flex-column">
                  <div>NOME: {{ item.name }}</div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-center align-items-center">
                  {{ item.responsible_for_payment ? "SIM" : "NÃO" }}
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-center align-items-center">
                  {{ item.guarantor == "SIM" ? "SIM" : "NÃO" }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-center">
          (Assinatura eletrônica)
          {{
            professionalClassCouncilValue({
              id: user.professional_class_council_id,
              name: user.name,
              profile: user.profile_name,
              cpf: user.cpf,
              office: user.office,
              value: user.professional_class_council_value,
            })
          }}
          <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
        </div>
        <v-btn class="v-warning float-right mt-2" v-on:click="printOut"
          >IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../lib/format";

import routes from "../../routes";

import moment from "moment";

import { userData } from "../../lib/functions";

import { getAge } from "../../lib/getAgeByDate";

export default {
  name: "PrintCustomer",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      errors: [],
      rest_home_id: "",
      customer: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      user: {},
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    getAge,
    formatDate,
    professionalClassCouncilValue,
    async retrieve() {
      const { id } = routes.history.current.params;

      const { user, permissions, logo } = userData();

      this.id = id;
      this.rest_home_id = user.rest_home_id;
      this.user = user;

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.permissions = permissions;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/customer/print", {
          params,
        });

        const { error, errors, customer } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.customer = customer;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut: () => window.print(),
  },
};
</script>

<style>
.pdf-print-customer .logo {
  height: 50px;
  object-fit: contain;
}
.pdf-print-customer .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.pdf-print-customer .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}
.pdf-print-customer table {
  width: 100% !important;
}
.pdf-print-customer table,
.pdf-print-customer td,
.pdf-print-customer th,
.pdf-print-customer tfoot {
  padding: 5px;
  cursor: auto !important;
}

.pdf-print-customer th {
  background-color: #f5f5f5;
}

.pdf-print-customer tr span {
  font-size: 15px;
}

@media print {
  .pdf-print-customer table {
    border: none !important;
    margin-top: 5px !important;
  }

  .pdf-print-customer footer {
    position: absolute;
    z-index: 9;
    width: 100% !important;
  }

  .pdf-print-customer button {
    display: none;
  }
}
</style>
